/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useRef, useEffect, useState } from "react";
import { db, auth } from "../firebase-config";
import { doc, updateDoc, getDoc } from "firebase/firestore";
import EditUser from "./EditUser.js";

export const SideBarMenu = ({
  sbm,
  openUsersPanel,
  openJukeboxPanel,
  openAutoPlayPanel,
  openHiddenChatPanel,
  funcProp,
  loadingAni,
  appMode,
  appLayoutMode,
  iconColor,
  userObj,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [runJukebox, setRunJukebox] = useState(false);
  const [canLogout, setCanLogout] = useState(false);
  const menuContainer = useRef(null);
  const [showUserModal, setShowUserModal] = useState(false);
  const [jukeboxUserObj, setJukeboxUserObj] = useState(userObj);

  const handleOutsideClick = (e) => {
    if (menuContainer.current && !menuContainer.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (auth.currentUser) {
      setCanLogout(!auth.currentUser.isAnonymous);
      if (!runJukebox) {
        setRunJukebox(true);
        openJukeboxPanel(true);
      }
    }
  }, []);

  // Outside-tap-to-close: attach only while the menu is open, listen for
  // `pointerdown` (unified touch+mouse — fires reliably on modern Android
  // including S25 Ultra, where `click` is not always synthesized for taps
  // on non-interactive areas). Capture phase so we run before nested
  // handlers can stop propagation.
  useEffect(() => {
    if (!isOpen) return;
    document.addEventListener("pointerdown", handleOutsideClick, true);
    return () => {
      document.removeEventListener("pointerdown", handleOutsideClick, true);
    };
  }, [isOpen]);

  useEffect(() => {
    // console.log("appMode", appMode);
  }, [appMode]);

  const handleSignOut = async () => {
    //before sign out update the user
    const docRef = doc(db, "users", auth.currentUser.uid);
    const docSnap = await getDoc(docRef);
    const currentChat = { currentChat: "none" };
    if (docSnap.exists()) {
      try {
        await updateDoc(docRef, { ...currentChat });
        sbm("sign out");
      } catch (err) {
        console.error(err);
      }
    }
  };

  useEffect(() => {
    setJukeboxUserObj(userObj);
  }, [userObj]);

  const showUser = (event, user) => {
    event.preventDefault();
    // console.log("showUser", user);
    setShowUserModal(true);
  };

  return (
    <>
      <div className="flex threedot-container">
        <div className="flex items-center justify-center relative ">
          <div
            className="thredotmenux cursor-pointer text-gray-800 dark:text-gray-800"
            onClick={() => setIsOpen(!isOpen)}
          >
            <div className="hamburgermenu"></div>
            <div className="hamburgermenu"></div>
            <div className="hamburgermenu"></div>
          </div>
          {isOpen && (
            // Full-viewport invisible backdrop. Catches any tap outside the
            // dropdown and closes it. This is more reliable than the
            // document-level pointerdown listener on devices (Samsung S24/S25
            // Ultra in particular) where the event chain up to `document` has
            // been flaky — here the tap hits an actual DOM node we own.
            // pointerdown is used (not click) because some Android touch
            // sequences never synthesise a `click` for taps on inert areas.
            <div
              className="fixed inset-0 z-[100]"
              style={{ background: 'transparent', touchAction: 'manipulation' }}
              onPointerDown={(e) => {
                // Belt-and-braces: only trigger if we really clicked the backdrop
                // itself, not a child that bubbled up through it.
                if (e.target === e.currentTarget) setIsOpen(false);
              }}
              onClick={(e) => {
                if (e.target === e.currentTarget) setIsOpen(false);
              }}
              aria-hidden="true"
            />
          )}
          {isOpen && (
            <div
              className="bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700 absolute top-7 right--10 md:top-20 z-[101] dropdownmenu"
              ref={menuContainer}
            >
              <ul
                className="py-2 text-sm text-gray-700 dark:text-gray-200"
                aria-labelledby="dropdownDefaultButton"
              >
                {window.location.hostname !== "admin.muuzbox.com" && (
                  <li>
                    <button
                      onClick={() => {
                        setIsOpen(!isOpen);
                        openJukeboxPanel(true);
                      }}
                      className="block w-full text-left px-4 py-2 text-white muuzmenuitem nodecor"
                    >
                      Jukebox
                    </button>
                  </li>
                )}
                {(!auth.currentUser.isAnonymous ||
                  (appMode && appMode.login === "true")) && (
                  <li>
                    <button
                      onClick={() => {
                        setIsOpen(!isOpen);
                        openAutoPlayPanel(true);
                      }}
                      className="block w-full text-left px-4 py-2 text-white muuzmenuitem nodecor"
                    >
                      Auto Play
                    </button>
                  </li>
                )}
                <li>
                  <button
                    className="block w-full text-left px-4 py-2 text-white muuzmenuitem nodecor"
                    onClick={(e) => {
                      // showJukebox(e);
                      showUser(e, jukeboxUserObj);
                    }}
                  >
                    Settings
                  </button>
                </li>
                {/* <li>
                  <button className="block w-full text-left px-4 py-2 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white muuzmenuitem">
                    Earnings
                  </button>
                </li>*/}
                <li>
                  <button
                    onClick={() => {
                      setIsOpen(!isOpen);
                      openUsersPanel(true);
                    }}
                    className="block w-full text-left px-4 py-2 text-white muuzmenuitem nodecor"
                  >
                    Search Members
                  </button>
                </li>
                {(!auth.currentUser.isAnonymous ||
                  (appMode && appMode.login === "true")) && (
                  <li>
                    <button
                      onClick={() => handleSignOut()}
                      className="block w-full text-left px-4 py-2 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white muuzmenuitem nodecor"
                    >
                      Sign out
                    </button>
                  </li>
                )}
                <li>
                  <button
                    onClick={() => {
                      setIsOpen(!isOpen);
                      loadingAni();
                      openHiddenChatPanel(true);
                    }}
                    className="block w-full text-left px-4 py-2 text-white muuzmenuitem nodecor"
                  >
                    My Chats
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => {
                      appLayoutMode("newlayout");
                    }}
                    className="block w-full text-left px-4 py-2 text-white muuzmenuitem nodecor"
                  >
                    Switch Layout
                  </button>
                </li>
                <li>
                  <button
                    id="notifyMuuzbox-close3"
                    className="block w-full text-left px-4 py-2 text-white muuzmenuitem nodecor"
                  >
                    Close Muuzbox
                  </button>
                </li>
                <li>
                  <button className="block w-full text-left text-sm px-4 py-2 text-white muuzmenuitem nodecor">
                    <strong>v 0.5.6</strong>
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
      {showUserModal && (
        <EditUser
          userObj={userObj}
          setShowUserModal={setShowUserModal}
          placeholderAvatar={jukeboxUserObj.photoURL}
        />
      )}
    </>
  );
};
